import React, { Component } from 'react'
import { withAuth } from '../AuthContext'
import { Link, withRouter } from 'react-router-dom'
import { shouldTranslateTo } from '../../utils/utils'
import Notification from './../Utils/Notification'
import Button from '../Utils/Button'
import { SUCCESS } from '../../utils/constants'

class ProofAddress extends Component {
  constructor(props) {
    super(props)
    this.state = {
      file: null,
      valid: true,
      checked: false,
      loading: false,
      responseMessage: null,
      pageText: [],
    }
  }

  componentDidMount() {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          this.setState({
            pageText: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('proof-address', language)
  }

  handleSwitchChange = (checked) => {
    this.setState({ checked })
  }

  handleChange = (e) => {
    this.setState({ file: e.target.files[0] })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    this.setState({ responseMessage: null })
    this.setState({ valid: true })

    const formData = new FormData()
    formData.append('file', this.state.file)
    const headers = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    axios
      .post(`/api/places/upload-proof`, formData, headers)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: this.state.pageText[0],
        })
        setTimeout(function () {
          window.open('/dashboard/edit-place', '_self')
        }, 2000)
      })
      .catch((err) => {
        this.setState({
          valid: false,
          responseMessage: this.state.pageText[1],
        })
      })
  }

  render() {
    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="contact_form">
                <h3
                  className="title"
                  dangerouslySetInnerHTML={{
                    __html: this.state.pageText[2],
                  }}
                ></h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: this.state.pageText[3],
                  }}
                ></p>
              </div>

              <form
                method="POST"
                action="/"
                name="myForm"
                aria-label="Verify Identity"
                onSubmit={(event) => {
                  event.preventDefault()
                  this.handleSubmit(event)
                  return false
                }}
              >
                <input
                  type="hidden"
                  name="csrf-token"
                  value={window.Laravel.csrfToken}
                />
                <div className="profile-wrapper">
                  <div className="col-12  form-group">
                    <label
                      dangerouslySetInnerHTML={{
                        __html: this.state.pageText[2],
                      }}
                    ></label>
                  </div>
                  <div className="col-12  form-group">
                    <input type="file" onChange={this.handleChange} />
                  </div>
                  <div className="col-12  form-group">
                    <Button
                      type="submit"
                      color="primary"
                      icon="fa fa-save"
                      loading={this.state.loading}
                    >
                      {this.state.pageText[4]}
                    </Button>
                    <Link
                      to="/dashboard/edit-place"
                      className="btn btn-warning ml-1"
                    >
                      {this.state.pageText[5]}
                    </Link>
                  </div>
                  {this.state.responseMessage && (
                    <div className="col-12">
                      <p className="text-danger">
                        {this.state.responseMessage}
                      </p>
                    </div>
                  )}
                  <div className="col-12">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.state.pageText[6],
                      }}
                    ></p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withAuth(ProofAddress))
